import Cookies from 'js-cookie';

export const handleLogout = () => {
  Cookies.remove('RBAC_TOKEN');
  Cookies.remove('RBAC_USER');

  Cookies.remove('RBAC_TOKEN', { path: '/', domain: '.tiangong.yl.163.com' });
  Cookies.remove('RBAC_USER', { path: '/', domain: '.tiangong.yl.163.com' });
  Cookies.remove('RBAC_TOKEN', { path: '/', domain: '.netease.com' });
  Cookies.remove('RBAC_USER', { path: '/', domain: '.netease.com' });
  Cookies.remove('RBAC_TOKEN', { path: '/', domain: '.danlu.netease.com' });
  Cookies.remove('RBAC_USER', { path: '/', domain: '.danlu.netease.com' });
  Cookies.remove('RBAC_TOKEN', { path: '/', domain: '.fuxi.netease.com' });
  Cookies.remove('RBAC_USER', { path: '/', domain: '.fuxi.netease.com' });
  Cookies.remove('P_INFO', { path: '/', domain: '.netease.com' });
  Cookies.remove('S_INFO', { path: '/', domain: '.netease.com' });
  Cookies.remove('P_INFO', { path: '/', domain: '.tiangong.yl.163.com' });
  Cookies.remove('S_INFO', { path: '/', domain: '.tiangong.yl.163.com' });
};
